import { createContext } from "react";

/**
 * Lets a descendant route (e.g. the tracking page) set the shared portal
 * navbar's font family. Undefined keeps the navbar's default font.
 */
export interface NavbarFontContextValue {
  fontFamily: string | undefined;
  setFontFamily: (fontFamily: string | undefined) => void;
}

export const NavbarFontContext = createContext<NavbarFontContextValue>({
  fontFamily: undefined,
  setFontFamily: () => {},
});
